import React from "react";
import { connect } from "react-redux";

import {
  addToCart,
  addToCompare,
  toggleWishlist,
  showQuickViewModal,
} from "../../../../actions";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductSix from "../../../features/product/product-six";
// import OwlCarousel from "../../../features/owl-carousel";

// import { mainSlider8 } from "../../../settings";

function RelatedProducts(props) {
  const {
    products,
    addToCart,
    toggleWishlist,
    addToCompare,
    showQuickViewModal,
  } = props;

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div>
      <Slider {...settings}>
        {products.map((item, index) => (
          <div className="pr-4" key={`product-${index}`}>
            <ProductSix
              product={item}
              onAddToCart={addToCart}
              onToggleWishlist={toggleWishlist}
              onAddToCompare={addToCompare}
              showQuickView={showQuickViewModal}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

const mapStateToProps = (state) => ({
  products: state.data.products,
});

export default connect(mapStateToProps, {
  addToCart,
  addToCompare,
  toggleWishlist,
  showQuickViewModal,
})(RelatedProducts);
